import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const CarIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M5 11l1.6-4.2A2 2 0 0 1 8.5 5.5h7a2 2 0 0 1 1.9 1.3L19 11" />
    <path d="M3 11h18v5H3z" />
    <path d="M5 16v2.5M19 16v2.5" />
    <circle cx="7" cy="13.5" r="0.6" />
    <circle cx="17" cy="13.5" r="0.6" />
  </svg>
);

export default CarIcon;
